import { UnsubscribeGroupsState } from '../../types/unsubscribeGroups/unsubscribeGroups.types';
import {
  GET_UNSUBSCRIBE_GROUPS_REQUEST,
  GET_UNSUBSCRIBE_GROUPS_SUCCESS,
  GET_UNSUBSCRIBE_GROUPS_FAILURE,
  GET_UNSUBSCRIBE_GROUP_REQUEST,
  GET_UNSUBSCRIBE_GROUP_SUCCESS,
  GET_UNSUBSCRIBE_GROUP_FAILURE,
  CREATE_UNSUBSCRIBE_GROUP_REQUEST,
  CREATE_UNSUBSCRIBE_GROUP_SUCCESS,
  CREATE_UNSUBSCRIBE_GROUP_FAILURE,
  UPDATE_UNSUBSCRIBE_GROUP_REQUEST,
  UPDATE_UNSUBSCRIBE_GROUP_SUCCESS,
  UPDATE_UNSUBSCRIBE_GROUP_FAILURE,
  DELETE_UNSUBSCRIBE_GROUP_REQUEST,
  DELETE_UNSUBSCRIBE_GROUP_SUCCESS,
  DELETE_UNSUBSCRIBE_GROUP_FAILURE,
  UnsubscribeGroupsActionTypes,
  CLEAR_UNSUBSCRIBE_GROUP_STATE,
} from './unsubscribeGroups.types';

const initialState: UnsubscribeGroupsState = {
  unsubscribeGroups: [],
  selectedUnsubscribeGroup: null,
  loading: false,
  error: null,
  success: false,
};

const unsubscribeGroupsReducer = (
  state: UnsubscribeGroupsState = initialState,
  action: UnsubscribeGroupsActionTypes
): UnsubscribeGroupsState => {
  switch (action.type) {
    case GET_UNSUBSCRIBE_GROUPS_REQUEST:
    case GET_UNSUBSCRIBE_GROUP_REQUEST:
    case CREATE_UNSUBSCRIBE_GROUP_REQUEST:
    case UPDATE_UNSUBSCRIBE_GROUP_REQUEST:
    case DELETE_UNSUBSCRIBE_GROUP_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_UNSUBSCRIBE_GROUPS_SUCCESS:
      return {
        ...state,
        loading: false,
        unsubscribeGroups: action.payload.unsubscribeGroups,
        error: null,
      };

    case GET_UNSUBSCRIBE_GROUP_SUCCESS:
      return {
        ...state,
        loading: false,
        selectedUnsubscribeGroup: action.payload,
        error: null,
      };

    case CREATE_UNSUBSCRIBE_GROUP_SUCCESS:
    case UPDATE_UNSUBSCRIBE_GROUP_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: true,
      };

    case DELETE_UNSUBSCRIBE_GROUP_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: true,
      };

    case GET_UNSUBSCRIBE_GROUPS_FAILURE:
    case GET_UNSUBSCRIBE_GROUP_FAILURE:
    case CREATE_UNSUBSCRIBE_GROUP_FAILURE:
    case UPDATE_UNSUBSCRIBE_GROUP_FAILURE:
    case DELETE_UNSUBSCRIBE_GROUP_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
      };

    case CLEAR_UNSUBSCRIBE_GROUP_STATE:
      return {
        ...state,
        success: false,
        error: null,
      };

    default:
      return state;
  }
};

export default unsubscribeGroupsReducer;
